<template>
  <div class="home">
    <section>
      <h2>Cricket Recent Matches</h2>
      <loading-state :state="cricketState"></loading-state>
      <div class="sub-content" v-if="cricketMatches.length">
        <div class="item link" v-for="match in cricketMatches" :key="match.key">
          <cricket-match-mini :match="match"></cricket-match-mini>
        </div>
      </div>
    </section>
    
    <section>
      <h2>Football Featured</h2>
      <loading-state :state="state"></loading-state>
      <section v-for="kind in listNames" :key="kind.status" v-if="matches[kind.status] && matches[kind.status].length">
        <h3>{{kind.name}}</h3>
        <div class="sub-content">
          <div class="item link" v-for="match in matches[kind.status]" :key="match.info.key">
            <football-match-mini :match="match"></football-match-mini>
          </div>
        </div>
      </section>
    </section>

  </div>
</template>

<script>
import { API } from '@/models/core'
import { homePage } from '@/models/cricket/core'
import { FootballMatch } from '@/models/match'
import { DataState } from '@/state'

export default {
  name: 'home',
  data () {
    return {
      listNames: [
        { name: 'Live', status: 'started' },
        { name: 'Upcoming', status: 'not_started' },
        { name: 'Completed', status: 'completed' }
      ],
      matches: {},
      cricketMatches: [],
      state: DataState.newLoading(),
      cricketState: DataState.newLoading()
    }
  },
  mounted () {
    FootballMatch.homePage().then((matches) => {
      this.matches = matches
      this.state.changeToLoaded()
    }).catch((error) => {
      this.state.changeToError(error)
    })

    homePage().then((response) => {
      this.cricketMatches = response.recentMatches
      this.cricketState.changeToLoaded()
    }).catch((error) => {
      this.cricketState.changeToError(error)
    })
  }
}
</script>
